// @ts-nocheck
import { parseInt } from "lodash";
import {
  convertTime,
  getFullTimeEstimate,
  getOverTimeEstimate,
  getTimeDiff,
  getTravelDaysPay,
  isTimeTBD,
  roundToNearestHalf,
} from "./calcUtils";

/**
 * fullTimeEstimate - regular pay on a particular day of a particular position
 * overTimeEstimate - additional pay on a particular day of a particular position
 * overT - midnight hours  
 * hours - regular hours
 * otHours - overtime hours
 * dtHours - double time hours
 * /

// TODO: rathern than put tD, we'll put the startTime, endTime and timeZone, with that we'll make a function to send the estimate calculation.
/**
 * for calculating estimate (estimat tab, and sow)
 */
export const calcEstimate = ({
  terms: term,
  appliedRate,
  data,
  breaks,
  isHalfDay,
  isHourlyRate = false,
}) => {
  let terms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    overTime: term?.overTime,
  };
  const { start, end, timezone, numberOfHours, travelDays, isClient } = data;
  const originalStart = convertTime({ dateStr: start, timezone });
  const originalEnd = convertTime({ dateStr: end, timezone });
  const {
    timeDiff: tD,
    afterFullTime,
    overtime: overT,
  } = getTimeDiff(originalStart, originalEnd, terms);

  let timeDiff = parseFloat(tD || numberOfHours);

  if (afterFullTime) {
    const { halfDay: hD, fullDay: fD, overTime: oT } = terms;

    const halfDay = parseFloat(hD);
    const fullDay = parseFloat(fD);
    const overTime = parseFloat(oT);

    const travelAmount = getTravelDaysPay({
      data: travelDays,
      isClient,
      halfDay: data?.halfDay,
      fullDay: data?.fullDay,
      appliedRate,
    });

    const firstBreak = parseFloat(breaks?.firstBreak) || 0;
    const secondBreak = parseFloat(breaks?.secondBreak) || 0;

    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }

    let estimate = 0;
    if (!timeDiff) {
      timeDiff = fullDay;
    }
    if (halfDay === 0 && fullDay === 0 && overTime === 0) {
      return 0;
    }
    if (timeDiff <= halfDay) {
      if (isHourlyRate) {
        estimate = appliedRate * timeDiff;
      } else {
        estimate = appliedRate * halfDay;
      }
    } else if (timeDiff <= fullDay) {
      if (isHourlyRate) {
        estimate = appliedRate * timeDiff;
      } else {
        estimate = appliedRate * fullDay;
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      estimate =
        appliedRate * fullDay + (timeDiff - fullDay) * (appliedRate * 1.5);
    } else {
      estimate =
        appliedRate * fullDay +
        overTime * (appliedRate * 1.5) +
        (timeDiff - fullDay - overTime) * (appliedRate * 2);
    }

    return roundToNearestHalf(estimate + travelAmount) || 0;
  } else {
    const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
    const halfDay = parseFloat(hD);
    const fullDay = parseFloat(fD);
    const overTime = parseFloat(oT);

    const travelAmount = getTravelDaysPay({
      data: travelDays,
      isClient,
      halfDay: data?.halfDay,
      fullDay: data?.fullDay,
      appliedRate,
    });

    const firstBreak = parseFloat(breaks?.firstBreak) || 0;
    const secondBreak = parseFloat(breaks?.secondBreak) || 0;

    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }

    let overTimePay = overT * appliedRate * 1.5;
    let estimate = 0;
    if (!timeDiff) {
      timeDiff = fullDay;
    }
    if (halfDay === 0 && fullDay === 0 && overTime === 0) {
      return 0;
    }
    if (timeDiff <= halfDay) {
      if (isHourlyRate) {
        estimate = appliedRate * (timeDiff - overT) + overTimePay;
      } else {
        estimate = appliedRate * (halfDay - overT) + overTimePay;
      }
    } else if (timeDiff <= fullDay) {
      if (isHourlyRate) {
        estimate = appliedRate * (timeDiff - overT) + overTimePay;
      } else {
        estimate = appliedRate * (fullDay - overT) + overTimePay;
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      estimate =
        appliedRate * (fullDay - overT) +
        (timeDiff - fullDay) * (appliedRate * 1.5) +
        overTimePay;
    } else {
      estimate =
        appliedRate * (fullDay - overT) +
        overTime * (appliedRate * 1.5) +
        (timeDiff - fullDay - overTime) * (appliedRate * 2) +
        overTimePay;
    }

    return roundToNearestHalf(estimate + travelAmount) || 0;
  }
};

/**
 * calculation of estimate with overtime pay and regular pay (estimate tab and sow)
 */
export const calcFullAndOtEstimate = ({
  terms: term,
  appliedRate,
  data,
  breaks,
  isHalfDay,
  isHourlyRate = false,
}) => {
  let terms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    overTime: term?.overTime,
  };
  const { start, end, timezone, numberOfHours, travelDays, isClient } = data;

  const originalStart = convertTime({ dateStr: start, timezone });
  const originalEnd = convertTime({ dateStr: end, timezone });
  const {
    timeDiff: tD,
    afterFullTime,
    overtime: overT,
  } = getTimeDiff(originalStart, originalEnd, terms);
  let timeDiff = parseFloat(tD || numberOfHours);

  const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
  const halfDay = parseFloat(hD);
  const fullDay = parseFloat(fD);
  const overTime = parseFloat(oT);

  const travelAmount = getTravelDaysPay({
    data: travelDays,
    isClient,
    halfDay: data?.halfDay,
    fullDay: data?.fullDay,
    appliedRate,
  });

  const firstBreak = parseFloat(breaks?.firstBreak) || 0;
  const secondBreak = parseFloat(breaks?.secondBreak) || 0;

  if (firstBreak) {
    timeDiff -= firstBreak;
  }
  if (secondBreak) {
    timeDiff -= secondBreak;
  }

  let fullTimeEstimate = 0;
  let overTimeEstimate = 0;

  if (!timeDiff) {
    timeDiff = fullDay;
  }

  if (halfDay === 0 && fullDay === 0 && overTime === 0) {
    return {
      fullTimeEstimate: roundToNearestHalf(fullTimeEstimate),
      overTimeEstimate: roundToNearestHalf(overTimeEstimate),
      travelAmount: travelAmount,
    };
  }

  let hours = 0,
    otHours = 0,
    dtHours = 0;

  if (afterFullTime) {
    if (timeDiff <= halfDay) {
      if (isHourlyRate) {
        fullTimeEstimate = appliedRate * timeDiff;
        hours = timeDiff;
      } else {
        fullTimeEstimate = appliedRate * halfDay;
        hours = halfDay;
      }
    } else if (timeDiff <= fullDay) {
      if (isHourlyRate) {
        fullTimeEstimate = appliedRate * timeDiff;
        hours = timeDiff;
      } else {
        fullTimeEstimate = appliedRate * fullDay;
        hours = fullDay;
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      fullTimeEstimate = appliedRate * fullDay;
      overTimeEstimate = (timeDiff - fullDay) * (appliedRate * 1.5);
      hours = fullDay;
      otHours = timeDiff - fullDay;
    } else {
      fullTimeEstimate = appliedRate * fullDay;
      overTimeEstimate =
        overTime * (appliedRate * 1.5) +
        (timeDiff - fullDay - overTime) * (appliedRate * 2);
      hours = fullDay;
      otHours = overTime;
      dtHours = timeDiff - fullDay - overTime;
    }
  } else {
    // const overTimePay = overT * appliedRate * 1.5;
    const overTimePay = 0;

    if (timeDiff <= halfDay) {
      if (isHourlyRate) {
        fullTimeEstimate = appliedRate * (timeDiff - overT);
        overTimeEstimate = overTimePay;
        hours = timeDiff - overT;
      } else {
        fullTimeEstimate = appliedRate * (halfDay - overT);
        overTimeEstimate = overTimePay;
        hours = halfDay - overT;
      }
    } else if (timeDiff <= fullDay) {
      if (isHourlyRate) {
        fullTimeEstimate = appliedRate * (timeDiff - overT);
        overTimeEstimate = overTimePay;
        hours = timeDiff - overT;
      } else {
        fullTimeEstimate = appliedRate * (fullDay - overT);
        overTimeEstimate = overTimePay;
        hours = fullDay - overT;
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      fullTimeEstimate = appliedRate * (fullDay - overT);
      overTimeEstimate =
        overTimePay + (timeDiff - fullDay) * (appliedRate * 1.5);
      hours = fullDay - overT;
      otHours = timeDiff - fullDay;
    } else {
      fullTimeEstimate = appliedRate * (fullDay - overT);
      overTimeEstimate =
        overTimePay +
        overTime * (appliedRate * 1.5) +
        (timeDiff - fullDay - overTime) * (appliedRate * 2);

      hours = fullDay - overT;
      otHours = overTime;
      dtHours = timeDiff - fullDay - overTime;
    }
  }

  return {
    fullTimeEstimate: getFullTimeEstimate({
      fullTimeEstimate,
      totalHours: overT + hours,
      rate: appliedRate,
    }),
    overTimeEstimate: getOverTimeEstimate({
      overTimeEstimate,
      overT,
      otHours,
      dtHours,
      rate: appliedRate,
    }),
    overT,
    hours,
    otHours,
    dtHours,
    travelAmount,
  };
};

export function calculateBreakHours({
  timeIn,
  timeOut,
  timezone,
  isWalkaway,
  numberOfHours,
}) {
  if (!isWalkaway) {
    return 0; // Breaks are counted only if isWalkaway is true.
  }

  // Handle TBD case with `numberOfHours`.
  if (isTimeTBD(timeIn) || isTimeTBD(timeOut)) {
    const noh = parseInt(numberOfHours);

    if (noh > 12) {
      return 2; // More than 12 hours → 2 breaks.
    } else if (noh > 6) {
      return 1; // More than 6 hours → 1 break.
    }
    return 0; // Less than or equal to 6 hours → no breaks.
  }

  const convertToTimeNumber = (timeStr) => {
    // Extract the hours and minutes from the ISO string
    const [hours, minutes] = timeStr.split("T")[1].split(":").map(Number);
    return hours * 100 + minutes;
  };

  const getTimeDifference = (start, end) => {
    const startHours = Math.floor(start / 100) + (start % 100) / 60;
    const endHours = Math.floor(end / 100) + (end % 100) / 60;
    return endHours >= startHours
      ? endHours - startHours
      : 24 - startHours + endHours;
  };

  // Use `convertTime` function to adjust time based on timezone.
  const convertedTimeIn = convertTime({ dateStr: timeIn, timezone });
  const convertedTimeOut = convertTime({ dateStr: timeOut, timezone });

  let startTime = convertToTimeNumber(convertedTimeIn);
  let endTime = convertToTimeNumber(convertedTimeOut);

  let totalHours = getTimeDifference(startTime, endTime);

  if (totalHours === 0) {
    return 0; // No work hours, no breaks.
  }

  // Exclude hours between midnight and 8 AM.
  let adjustedHours = totalHours;
  if (startTime < 800) {
    const before8AM = getTimeDifference(startTime, Math.min(800, endTime));
    adjustedHours -= before8AM;
  }
  if (endTime < 800) {
    const after12AM = getTimeDifference(Math.max(startTime, 0), endTime);
    adjustedHours -= after12AM;
  }

  // Break rules:
  let breaks = 0;
  if (adjustedHours > 12) {
    breaks = 2; // More than 12 hours → 2 breaks.
  } else if (adjustedHours > 6) {
    breaks = 1; // More than 6 hours → 1 break.
  } else {}

  // Ensure breaks are spaced correctly.
  const breakDuration = 1;
  const remainingTimeAfterBreaks = adjustedHours - breaks * breakDuration;
  if (remainingTimeAfterBreaks <= 0) {
    breaks = Math.max(0, Math.floor(adjustedHours / (breakDuration + 1)));
  }

  return breaks * breakDuration; // Total hours spent on breaks.
}

/**
 * calculation of estimate on PO
 */
export const calcEstimateForPO = ({
  terms: term,
  appliedRate,
  data,
  breaks,
  givenOtAndDt,
  isHalfDay,
  isHourlyRate = false,
}) => {
  const terms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    overTime: term?.overTime,
  };
  const { start, end, timezone, numberOfHours, travelDays, isClient } = data;
  const originalStart = convertTime({ dateStr: start, timezone });
  const originalEnd = convertTime({ dateStr: end, timezone });
  const {
    timeDiff: tD,
    afterFullTime,
    overtime: overT,
  } = getTimeDiff(originalStart, originalEnd, terms);
  const { givenOt: gOt, givenDt: gDt, givenMOt: gMOt } = givenOtAndDt;
  const givenOt = parseFloat(gOt || 0);
  const givenDt = parseFloat(gDt || 0);
  const givenMOt = parseFloat(gMOt || 0);

  let timeDiff = parseFloat(tD || numberOfHours);
  const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
  const halfDay = parseFloat(hD);
  const fullDay = parseFloat(fD);
  const overTime = parseFloat(oT);

  const travelAmount = getTravelDaysPay({
    data: travelDays,
    isClient,
    halfDay: data?.halfDay,
    fullDay: data?.fullDay,
    appliedRate,
  });

  const firstBreak = parseFloat(breaks?.firstBreak) || 0;
  const secondBreak = parseFloat(breaks?.secondBreak) || 0;

  let otHours = 0;
  let dtHours = 0;
  let ftHours = 0;
  if (!(gOt || gDt || gMOt)) {
    if (afterFullTime) {
      if (firstBreak) {
        timeDiff -= firstBreak;
      }
      if (secondBreak) {
        timeDiff -= secondBreak;
      }

      let estimate = 0;
      if (!timeDiff) {
        timeDiff = fullDay;
      }
      if (halfDay === 0 && fullDay === 0 && overTime === 0) {
        return 0;
      }
      if (timeDiff <= halfDay) {
        if (isHourlyRate) {
          estimate = appliedRate * timeDiff;
        } else {
          estimate = appliedRate * halfDay;
        }
        ftHours = halfDay;
      } else if (timeDiff <= fullDay) {
        if (isHourlyRate) {
          estimate = appliedRate * timeDiff;
          ftHours = timeDiff;
        } else {
          estimate = appliedRate * fullDay;
          ftHours = fullDay;
        }
      } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
        otHours = timeDiff - fullDay;
        estimate = appliedRate * fullDay + otHours * (appliedRate * 1.5);
        ftHours = fullDay;
      } else {
        otHours = overTime;
        dtHours = timeDiff - fullDay - overTime;
        ftHours = fullDay;
        estimate =
          appliedRate * fullDay +
          overTime * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2);
      }

      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        overT: 0,
        ftHours,
        otHours,
        dtHours,
        travelAmount,
      };
    } else {
      if (firstBreak) {
        timeDiff -= firstBreak;
      }
      if (secondBreak) {
        timeDiff -= secondBreak;
      }

      let overTimePay = overT * appliedRate * 1.5;
      let estimate = 0;
      if (!timeDiff) {
        timeDiff = fullDay;
      }
      if (halfDay === 0 && fullDay === 0 && overTime === 0) {
        return 0;
      }
      if (timeDiff <= halfDay) {
        if (isHourlyRate) {
          ftHours = timeDiff - overT;
          estimate = appliedRate * (timeDiff - overT) + overTimePay;
        } else {
          // otHours = overT;
          ftHours = halfDay - overT;
          estimate = appliedRate * (halfDay - overT) + overTimePay;
        }
      } else if (timeDiff <= fullDay) {
        if (isHourlyRate) {
          ftHours = timeDiff - overT;
          estimate = appliedRate * (timeDiff - overT) + overTimePay;
        } else {
          // otHours = overT;
          ftHours = fullDay - overT;
          estimate = appliedRate * (fullDay - overT) + overTimePay;
        }
      } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
        // otHours = overT + (timeDiff - fullDay);
        otHours = timeDiff - fullDay;
        ftHours = fullDay - overT;
        estimate =
          appliedRate * (fullDay - overT) +
          (timeDiff - fullDay) * (appliedRate * 1.5) +
          overTimePay;
      } else {
        // otHours = overTime + overT;
        otHours = overTime;
        dtHours = timeDiff - fullDay - overTime;
        ftHours = fullDay - overT;
        estimate =
          appliedRate * (fullDay - overT) +
          overTime * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          overTimePay;
      }

      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        overT,
        ftHours: ftHours + overT,
        otHours,
        dtHours,
        travelAmount,
      };
    }
  } else {
    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }
    let fixedFt = 0;
    if (!(givenOt || givenDt)) {
      if (timeDiff <= terms?.fullDay && timeDiff > terms?.halfDay) {
        fixedFt = terms?.fullDay;
      } else if (timeDiff <= terms?.halfDay && timeDiff > 0) {
        fixedFt = terms?.halfDay;
      }
    }

    let midnightHoursPrice = givenMOt * 0.5 * appliedRate;

    if (gOt && gDt) {
      otHours = givenOt;
      dtHours = givenDt;
      // const ftHours = Math.max(timeDiff - givenOt - givenDt, 0, fixedFt);
      let initialFtHours = 0;
      if (isHourlyRate) {
        initialFtHours = Math.max(timeDiff - givenOt - givenDt, 0);
      } else {
        initialFtHours = Math.max(timeDiff - givenOt - givenDt, 0, fixedFt);
      }
      let ftHours;

      if (initialFtHours <= halfDay && !isHourlyRate) {
        ftHours = halfDay;
      } else if (initialFtHours <= fullDay && !isHourlyRate) {
        ftHours = fullDay;
      } else {
        // Round up to nearest 0.5
        ftHours = Math.ceil(initialFtHours * 2) / 2;
      }
      let estimate = 0;
      estimate =
        ftHours * appliedRate +
        otHours * (appliedRate * 1.5) +
        dtHours * (appliedRate * 2) +
        midnightHoursPrice;
      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
        travelAmount,
      };
    } else if (gOt && !gDt) {
      otHours = givenOt;
      let estimate = 0;
      let ftHours = 0;
      let initialFtHours = 0;
      if (timeDiff <= fullDay) {
        initialFtHours = timeDiff - otHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          midnightHoursPrice;
      } else {
        let ftHours = 0;
        let initialFtHours = 0;
        dtHours = Math.max(timeDiff - fullDay - otHours, 0, fixedFt);
        initialFtHours = timeDiff - dtHours - otHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      }
      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
        travelAmount,
      };
    } else if (gDt && !gOt) {
      let ftHours = 0;
      let initialFtHours = 0;
      dtHours = givenDt;
      let estimate = 0;
      if (timeDiff <= fullDay) {
        initialFtHours = timeDiff - dtHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      } else {
        let ftHours = 0;
        let initialFtHours = 0;
        otHours = Math.max(timeDiff - fullDay - dtHours, 0, fixedFt);
        initialFtHours = timeDiff - otHours - dtHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      }
      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
        travelAmount,
      };
    }
  }
};

/**
 * calculation of estimatme in invocie (for client)
 */
export const calcEstimateForInvoice = ({
  terms: term,
  appliedRate: aR,
  data,
  breaks,
  givenOtAndDt,
  isHalfDay,
  isHDOverride,
  isHourlyRate = false,
}) => {
  let terms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    // overTime: isHalfDay
    //   ? term?.fullDay + term?.overTime - term?.halfDay
    //   : term?.overTime,
    overTime: term?.overTime,
  };
  let appliedRate = aR;
  const { start, end, timezone, numberOfHours, travelDays, isClient } = data;
  const originalStart = convertTime({ dateStr: start, timezone });
  const originalEnd = convertTime({ dateStr: end, timezone });
  const {
    timeDiff: tD,
    afterFullTime,
    overtime: overT,
  } = getTimeDiff(originalStart, originalEnd, terms);
  const { givenOt: gOt, givenDt: gDt, givenMOt: gMOt } = givenOtAndDt;
  const givenOt = parseFloat(gOt || 0);
  const givenDt = parseFloat(gDt || 0);
  const givenMOt = parseFloat(gMOt || 0);

  let timeDiff = parseFloat(tD || numberOfHours);
  if (timeDiff > term?.halfDay + 1 && !isHDOverride && isHalfDay) {
    terms = term;
    // appliedRate = aR - 5;
  }

  const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
  const halfDay = parseFloat(hD);
  const fullDay = parseFloat(fD);
  const overTime = parseFloat(oT);

  const travelAmount = getTravelDaysPay({
    data: travelDays,
    isClient,
    halfDay: data?.halfDay,
    fullDay: data?.fullDay,
    appliedRate,
  });

  const firstBreak = parseFloat(breaks?.firstBreak) || 0;
  const secondBreak = parseFloat(breaks?.secondBreak) || 0;

  let otHours = 0;
  let dtHours = 0;
  let ftHours = 0;
  if (!(gOt || gDt || gMOt)) {
    if (afterFullTime) {
      if (firstBreak) {
        timeDiff -= firstBreak;
      }
      if (secondBreak) {
        timeDiff -= secondBreak;
      }

      let estimate = 0;
      if (!timeDiff) {
        timeDiff = fullDay;
      }
      if (halfDay === 0 && fullDay === 0 && overTime === 0) {
        return 0;
      }
      if (timeDiff <= halfDay) {
        if (isHourlyRate) {
          estimate = appliedRate * timeDiff;
          ftHours = timeDiff;
        } else {
          estimate = appliedRate * halfDay;
          ftHours = halfDay;
        }
      } else if (timeDiff <= fullDay) {
        if (isHourlyRate) {
          estimate = appliedRate * timeDiff;
          ftHours = timeDiff;
        } else {
          estimate = appliedRate * fullDay;
          ftHours = fullDay;
        }
      } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
        otHours = timeDiff - fullDay;
        estimate = appliedRate * fullDay + otHours * (appliedRate * 1.5);
        ftHours = fullDay;
      } else {
        otHours = overTime;
        dtHours = timeDiff - fullDay - overTime;
        ftHours = fullDay;
        estimate =
          appliedRate * fullDay +
          overTime * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2);
      }

      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        overT: 0,
        ftHours,
        otHours,
        dtHours,
        travelAmount,
      };
    } else {
      if (firstBreak) {
        timeDiff -= firstBreak;
      }
      if (secondBreak) {
        timeDiff -= secondBreak;
      }

      let overTimePay = overT * appliedRate * 1.5;
      let estimate = 0;
      if (!timeDiff) {
        timeDiff = fullDay;
      }
      if (halfDay === 0 && fullDay === 0 && overTime === 0) {
        return 0 + travelAmount;
      }
      if (timeDiff <= halfDay) {
        if (isHourlyRate) {
          ftHours = timeDiff - overT;
          estimate = appliedRate * (timeDiff - overT) + overTimePay;
        } else {
          // otHours = overT;
          ftHours = halfDay - overT;
          estimate = appliedRate * (halfDay - overT) + overTimePay;
        }
      } else if (timeDiff <= fullDay) {
        if (isHourlyRate) {
          ftHours = timeDiff - overT;
          estimate = appliedRate * (timeDiff - overT) + overTimePay;
        } else {
          // otHours = overT;
          ftHours = fullDay - overT;
          estimate = appliedRate * (fullDay - overT) + overTimePay;
        }
      } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
        // otHours = overT + (timeDiff - fullDay);
        otHours = timeDiff - fullDay;
        ftHours = fullDay - overT;
        estimate =
          appliedRate * (fullDay - overT) +
          (timeDiff - fullDay) * (appliedRate * 1.5) +
          overTimePay;
      } else {
        // otHours = overTime + overT;
        otHours = overTime;
        dtHours = timeDiff - fullDay - overTime;
        ftHours = fullDay - overT;
        estimate =
          appliedRate * (fullDay - overT) +
          overTime * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          overTimePay;
      }

      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        overT,
        ftHours,
        otHours,
        dtHours,
        travelAmount,
      };
    }
  } else {
    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }
    let fixedFt = 0;
    if (!(givenOt || givenDt)) {
      if (timeDiff <= terms?.fullDay && timeDiff > terms?.halfDay) {
        fixedFt = terms?.fullDay;
      } else if (timeDiff <= terms?.halfDay && timeDiff > 0) {
        fixedFt = terms?.halfDay;
      }
    }

    let midnightHoursPrice = givenMOt * 0.5 * appliedRate;

    if (gOt && gDt) {
      otHours = givenOt;
      dtHours = givenDt;
      // const ftHours = Math.max(timeDiff - givenOt - givenDt, 0, fixedFt);
      let ftHours = 0;
      let initialFtHours = 0;
      if (isHourlyRate) {
        initialFtHours = Math.max(timeDiff - givenOt - givenDt, 0);
      } else {
        initialFtHours = Math.max(timeDiff - givenOt - givenDt, 0, fixedFt);
      }

      if (initialFtHours <= halfDay && !isHourlyRate) {
        ftHours = halfDay;
      } else if (initialFtHours <= fullDay && !isHourlyRate) {
        ftHours = fullDay;
      } else {
        // Round up to nearest 0.5
        ftHours = Math.ceil(initialFtHours * 2) / 2;
      }
      let estimate = 0;
      estimate =
        (ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2)) |
        midnightHoursPrice;
      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
        travelAmount,
      };
    } else if (gOt && !gDt) {
      otHours = givenOt;
      let estimate = 0;
      let ftHours = 0;
      let initialFtHours = 0;
      if (timeDiff <= fullDay) {
        initialFtHours = timeDiff - otHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          midnightHoursPrice;
      } else {
        let ftHours = 0;
        let initialFtHours = 0;
        dtHours = Math.max(timeDiff - fullDay - otHours, 0, fixedFt);
        initialFtHours = timeDiff - dtHours - otHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      }
      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
        travelAmount,
      };
    } else if (gDt && !gOt) {
      let ftHours = 0;
      let initialFtHours = 0;
      dtHours = givenDt;
      let estimate = 0;
      if (timeDiff <= fullDay) {
        initialFtHours = timeDiff - dtHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      } else {
        let ftHours = 0;
        let initialFtHours = 0;
        otHours = Math.max(timeDiff - fullDay - dtHours, 0, fixedFt);
        initialFtHours = timeDiff - otHours - dtHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      }
      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
        travelAmount,
      };
    }
  }
};

/**
 *  sow calculation for california states
 */
export const calcEstimateCalifornia = ({
  terms: term,
  appliedRate,
  data,
  breaks,
  isHalfDay,
  isHourlyRate = false,
}) => {
  let terms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    overTime: term?.overTime,
  };
  let fixedTerms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    overTime: term?.overTime,
  };
  const { start, end, timezone, numberOfHours, travelDays, isClient } = data;
  const originalStart = convertTime({ dateStr: start, timezone });
  const originalEnd = convertTime({ dateStr: end, timezone });
  const {
    timeDiff: tD,
    afterFullTime,
    overtime: overT,
  } = getTimeDiff(originalStart, originalEnd, terms);

  let timeDiff = parseFloat(tD || numberOfHours);

  if (afterFullTime) {
    const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
    const halfDay = parseFloat(hD);
    const fullDay = parseFloat(fD);
    const overTime = parseFloat(oT);

    const travelAmount = getTravelDaysPay({
      data: travelDays,
      isClient,
      halfDay: data?.halfDay,
      fullDay: data?.fullDay,
      appliedRate,
    });

    const firstBreak = parseFloat(breaks?.firstBreak) || 0;
    const secondBreak = parseFloat(breaks?.secondBreak) || 0;

    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }

    let estimate = 0;
    if (!timeDiff) {
      timeDiff = fullDay;
    }

    // NOTE: california permanent ot
    let californiaPermanentOt = 0;
    let californiaPermanentOtHours = 0;
    if (
      timeDiff <= fullDay + 2 &&
      timeDiff > halfDay &&
      !isHourlyRate &&
      !isHalfDay
    ) {
      californiaPermanentOt = 2 * appliedRate * 1.5;
      californiaPermanentOtHours = 2;
    }

    if (halfDay === 0 && fullDay === 0 && overTime === 0) {
      return 0 + travelAmount;
    }
    if (timeDiff <= halfDay) {
      if (isHourlyRate) {
        estimate = appliedRate * timeDiff;
      } else {
        estimate = appliedRate * halfDay;
      }
    } else if (timeDiff <= fixedTerms.fullDay + californiaPermanentOtHours) {
      if (isHourlyRate || isHalfDay) {
        if (isHalfDay) {
          estimate = appliedRate * fullDay;
        } else if (isHourlyRate) {
          if (timeDiff > fullDay) {
            estimate =
              appliedRate * fullDay + appliedRate * 1.5 * (timeDiff - fullDay);
          } else {
            estimate = appliedRate * timeDiff;
          }
        }
      } else {
        estimate = appliedRate * fullDay + californiaPermanentOt;
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      estimate =
        appliedRate * fullDay +
        Math.max(timeDiff - fullDay, 0) * (appliedRate * 1.5);
    } else {
      estimate =
        appliedRate * fullDay +
        overTime * (appliedRate * 1.5) +
        (timeDiff - fullDay - overTime) * (appliedRate * 2);
    }

    return roundToNearestHalf(estimate + travelAmount || 0);
  } else {
    const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
    const halfDay = parseFloat(hD);
    const fullDay = parseFloat(fD);
    const overTime = parseFloat(oT);

    const travelAmount = getTravelDaysPay({
      data: travelDays,
      isClient,
      halfDay: data?.halfDay,
      fullDay: data?.fullDay,
      appliedRate,
    });

    const firstBreak = parseFloat(breaks?.firstBreak) || 0;
    const secondBreak = parseFloat(breaks?.secondBreak) || 0;

    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }

    let overTimePay = overT * appliedRate * 1.5;
    let estimate = 0;
    if (!timeDiff) {
      timeDiff = fullDay;
    }

    let californiaPermanentOt = 0;
    let californiaPermanentOtHours = 0;
    if (
      timeDiff <= fullDay + 2 &&
      timeDiff > halfDay &&
      !isHourlyRate &&
      !isHalfDay
    ) {
      californiaPermanentOt = 2 * appliedRate * 1.5;
      californiaPermanentOtHours = 2;
    }

    if (halfDay === 0 && fullDay === 0 && overTime === 0) {
      return 0 + travelAmount;
    }
    if (timeDiff <= fixedTerms.halfDay) {
      if (isHourlyRate) {
        estimate = appliedRate * (timeDiff - overT) + overTimePay;
      } else {
        estimate = appliedRate * (halfDay - overT) + overTimePay;
      }
    } else if (timeDiff <= fixedTerms.fullDay + californiaPermanentOtHours) {
      if (isHourlyRate) {
        estimate = appliedRate * (timeDiff - overT) + overTimePay;
      } else {
        if (isHalfDay) {
          estimate = appliedRate * fullDay;
        } else {
          estimate =
            appliedRate * (fullDay - overT) +
            overTimePay +
            californiaPermanentOt;
        }
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      estimate =
        appliedRate * (fullDay - overT) +
        (timeDiff - fullDay) * (appliedRate * 1.5) +
        overTimePay;
    } else {
      estimate =
        appliedRate * (fullDay - overT) +
        overTime * (appliedRate * 1.5) +
        (timeDiff - fullDay - overTime) * (appliedRate * 2) +
        overTimePay;
    }

    return roundToNearestHalf(estimate + travelAmount || 0);
  }
};

/**
 * check if the california state has ot
 */
export const hasOtForCaliforniaEstimate = ({
  terms: term,
  appliedRate,
  data,
  breaks,
  isHalfDay,
  isHourlyRate = false,
}) => {
  let terms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    overTime: term?.overTime,
  };
  let fixedTerms = {
    halfDay: isHalfDay ? 0 : 5,
    fullDay: isHalfDay ? term?.halfDay : 10,
    overTime: 2,
  };
  const { start, end, timezone, numberOfHours } = data;
  const originalStart = convertTime({ dateStr: start, timezone });
  const originalEnd = convertTime({ dateStr: end, timezone });
  const {
    timeDiff: tD,
    afterFullTime,
    overtime: overT,
  } = getTimeDiff(originalStart, originalEnd, terms);

  let timeDiff = parseFloat(tD || numberOfHours);

  if (afterFullTime) {
    const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
    const halfDay = parseFloat(hD);
    const fullDay = parseFloat(fD);
    const overTime = parseFloat(oT);

    const firstBreak = parseFloat(breaks?.firstBreak) || 0;
    const secondBreak = parseFloat(breaks?.secondBreak) || 0;

    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }

    if (!timeDiff) {
      timeDiff = fullDay;
    }

    // NOTE: california permanent ot
    let californiaPermanentOtHours = 0;
    if (
      timeDiff <= fullDay + 2 &&
      timeDiff > halfDay &&
      !isHourlyRate &&
      !isHalfDay
    ) {
      californiaPermanentOtHours = 2;
    }

    if (halfDay === 0 && fullDay === 0 && overTime === 0) {
      return false;
    }
    if (timeDiff <= halfDay) {
      if (isHourlyRate) {
        return false;
      } else {
        return false;
      }
    } else if (timeDiff <= fixedTerms.fullDay + californiaPermanentOtHours) {
      if (isHourlyRate || isHalfDay) {
        if (isHalfDay) {
          return false;
        } else if (isHourlyRate) {
          if (timeDiff > fullDay) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return true;
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      return true;
    } else {
      return true;
    }
  } else {
    const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
    const halfDay = parseFloat(hD);
    const fullDay = parseFloat(fD);
    const overTime = parseFloat(oT);

    const firstBreak = parseFloat(breaks?.firstBreak) || 0;
    const secondBreak = parseFloat(breaks?.secondBreak) || 0;

    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }

    if (!timeDiff) {
      timeDiff = fullDay;
    }

    let californiaPermanentOtHours = 0;
    if (
      timeDiff <= fullDay + 2 &&
      timeDiff > halfDay &&
      !isHourlyRate &&
      !isHalfDay
    ) {
      californiaPermanentOtHours = 2;
    }

    if (halfDay === 0 && fullDay === 0 && overTime === 0) {
      return false;
    }
    if (timeDiff <= fixedTerms.halfDay) {
      if (isHourlyRate) {
        return false;
      } else {
        return false;
      }
    } else if (timeDiff <= fixedTerms.fullDay + californiaPermanentOtHours) {
      if (isHourlyRate) {
        return false;
      } else {
        if (isHalfDay) {
          return false;
        } else {
          return true;
        }
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      return true;
    } else {
      return true;
    }
  }
};

/**
 * po calculation for california state
 */
export const calcEstimateForCaliforniaPO = ({
  terms: term,
  appliedRate,
  data,
  breaks,
  givenOtAndDt,
  isHalfDay,
  isHourlyRate = false,
  isFullDayPos = false,
}) => {
  const terms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    overTime: term?.overTime,
  };
  let fixedTerms = {
    halfDay: 5,
    fullDay: 10,
    overTime: 2,
  };
  const { start, end, timezone, numberOfHours, travelDays, isClient } = data;
  const originalStart = convertTime({ dateStr: start, timezone });
  const originalEnd = convertTime({ dateStr: end, timezone });
  const {
    timeDiff: tD,
    afterFullTime,
    overtime: overT,
  } = getTimeDiff(originalStart, originalEnd, terms);
  const { givenOt: gOt, givenDt: gDt, givenMOt: gMOt } = givenOtAndDt;
  const givenOt = parseFloat(gOt || 0);
  const givenDt = parseFloat(gDt || 0);
  const givenMOt = parseFloat(gMOt || 0);

  let timeDiff = parseFloat(tD || numberOfHours);
  const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
  const halfDay = parseFloat(hD);
  const fullDay = parseFloat(fD);
  const overTime = parseFloat(oT);

  const travelAmount = getTravelDaysPay({
    data: travelDays,
    isClient,
    halfDay: data?.halfDay,
    fullDay: data?.fullDay,
    appliedRate,
  });

  const firstBreak = parseFloat(breaks?.firstBreak) || 0;
  const secondBreak = parseFloat(breaks?.secondBreak) || 0;

  let otHours = 0;
  let dtHours = 0;
  let ftHours = 0;
  if (!(gOt || gDt || gMOt)) {
    if (afterFullTime) {
      if (firstBreak) {
        timeDiff -= firstBreak;
      }
      if (secondBreak) {
        timeDiff -= secondBreak;
      }

      let estimate = 0;
      if (!timeDiff) {
        timeDiff = fullDay;
      }
      let californiaPermanentOt = 0;
      let californiaPermanentOtHours = 0;
      if (
        timeDiff <= fullDay + 2 &&
        timeDiff > halfDay &&
        !isHourlyRate &&
        !isHalfDay
      ) {
        californiaPermanentOt = 2 * appliedRate * 1.5;
        californiaPermanentOtHours = 2;
      }

      if (halfDay === 0 && fullDay === 0 && overTime === 0) {
        return 0 + travelAmount;
      }
      if (timeDiff <= halfDay) {
        if (isHourlyRate) {
          estimate = appliedRate * timeDiff;
          ftHours = timeDiff;
        } else {
          estimate = appliedRate * halfDay;
          ftHours = halfDay;
        }
      } else if (timeDiff <= fixedTerms?.fullDay) {
        if (isHourlyRate) {
          estimate = appliedRate * timeDiff;
          ftHours = timeDiff;
        } else if (isHalfDay || isHourlyRate) {
          estimate =
            appliedRate * fullDay +
            Math.max(timeDiff - fullDay, 0) * 1.5 * appliedRate;
          ftHours = fullDay;
          otHours = Math.max(timeDiff - fullDay, 0);
        } else {
          estimate = appliedRate * fullDay + californiaPermanentOt;
          ftHours = fullDay;
          otHours = californiaPermanentOtHours;
        }
      } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
        otHours = timeDiff - fullDay;
        estimate = appliedRate * fullDay + otHours * (appliedRate * 1.5);
        ftHours = fullDay;
      } else {
        otHours = overTime;
        dtHours = timeDiff - fullDay - overTime;
        ftHours = fullDay;
        estimate =
          appliedRate * fullDay +
          overTime * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2);
      }

      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        overT: 0,
        ftHours,
        otHours,
        dtHours,
        travelAmount,
      };
    } else {
      if (firstBreak) {
        timeDiff -= firstBreak;
      }
      if (secondBreak) {
        timeDiff -= secondBreak;
      }

      let overTimePay = overT * appliedRate * 1.5;
      let estimate = 0;
      if (!timeDiff) {
        timeDiff = fullDay;
      }
      let californiaPermanentOt = 0;
      let californiaPermanentOtHours = 0;
      if (
        timeDiff <= fullDay + 2 &&
        timeDiff < halfDay &&
        !isHalfDay &&
        !isHourlyRate
      ) {
        californiaPermanentOt = 2 * appliedRate * 1.5;
        californiaPermanentOtHours = 2;
      }

      if (halfDay === 0 && fullDay === 0 && overTime === 0) {
        return 0 + travelAmount;
      }
      if (timeDiff <= halfDay) {
        if (isHourlyRate) {
          otHours = overT;
          ftHours = timeDiff - overT;
          estimate = appliedRate * (timeDiff - overT) + overTimePay;
        } else {
          otHours = overT;
          ftHours = halfDay - overT;
          estimate = appliedRate * (halfDay - overT) + overTimePay;
        }
      } else if (timeDiff <= fixedTerms.fullDay + californiaPermanentOtHours) {
        if (isHourlyRate) {
          // otHours = overT;
          ftHours = timeDiff - overT;
          estimate = appliedRate * (timeDiff - overT) + overTimePay;
        } else {
          otHours = californiaPermanentOtHours;
          ftHours = fullDay - overT;
          estimate =
            appliedRate * (fullDay - overT) +
            overTimePay +
            californiaPermanentOt;
        }
      } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
        // otHours = overT + (timeDiff - fullDay);
        otHours = timeDiff - fullDay;
        ftHours = fullDay - overT;
        estimate =
          appliedRate * (fullDay - overT) +
          (timeDiff - fullDay) * (appliedRate * 1.5) +
          overTimePay;
      } else {
        otHours = overTime;
        dtHours = timeDiff - fullDay - overTime;
        ftHours = fullDay - overT;
        estimate =
          appliedRate * (fullDay - overT) +
          overTime * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          overTimePay;
      }

      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        ftHours: ftHours + overT,
        otHours,
        dtHours,
        overT,
        travelAmount,
      };
    }
  } else {
    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }

    let fixedFt = 0;
    if (!(givenOt || givenDt)) {
      if (timeDiff <= terms?.fullDay && timeDiff > terms?.halfDay) {
        fixedFt = terms?.fullDay;
      } else if (timeDiff <= terms?.halfDay && timeDiff > 0) {
        fixedFt = terms?.halfDay;
      }
    } else {
      if (terms?.halfDay == 0 && isFullDayPos) {
        fixedFt = terms?.fullDay;
      }
    }
    let midnightHoursPrice = givenMOt * 0.5 * appliedRate;
    if (gOt && gDt) {
      otHours = givenOt;
      dtHours = givenDt;
      // const ftHours = Math.max(timeDiff - givenOt - givenDt, 0, fixedFt);
      let initialFtHours = 0;
      if (isHourlyRate) {
        initialFtHours = Math.max(timeDiff - givenOt - givenDt, 0);
      } else {
        initialFtHours = Math.max(timeDiff - givenOt - givenDt, 0, fixedFt);
      }
      let ftHours;
      if (initialFtHours <= halfDay && !isHourlyRate) {
        ftHours = halfDay;
      } else if (initialFtHours <= fullDay && !isHourlyRate) {
        ftHours = fullDay;
      } else {
        // Round up to nearest 0.5
        ftHours = Math.ceil(initialFtHours * 2) / 2;
      }
      let estimate = 0;
      estimate =
        ftHours * appliedRate +
        otHours * (appliedRate * 1.5) +
        dtHours * (appliedRate * 2) +
        midnightHoursPrice;
      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
        travelAmount,
      };
    } else if (gOt && !gDt) {
      otHours = givenOt;
      let estimate = 0;
      let ftHours = 0;
      let initialFtHours = 0;
      if (timeDiff <= fullDay) {
        initialFtHours = timeDiff - otHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        // ftHours = timeDiff - otHours;
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          midnightHoursPrice;
      } else {
        let ftHours = 0;
        let initialFtHours = 0;
        dtHours = Math.max(timeDiff - fullDay - otHours, 0, fixedFt);
        // ftHours = timeDiff - dtHours - otHours;
        initialFtHours = timeDiff - dtHours - otHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      }
      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
        travelAmount,
      };
    } else if (gDt && !gOt) {
      let ftHours = 0;
      let initialFtHours = 0;
      dtHours = givenDt;
      let estimate = 0;
      if (timeDiff <= fullDay) {
        if (timeDiff <= fixedTerms.fullDay && timeDiff > halfDay) {
          ftHours = timeDiff - dtHours;
          otHours = 2;
          estimate =
            ftHours * appliedRate +
            dtHours * (appliedRate * 2) +
            midnightHoursPrice;
        } else {
          // ftHours = timeDiff - dtHours;
          initialFtHours = timeDiff - dtHours;
          if (initialFtHours <= halfDay && !isHourlyRate) {
            ftHours = halfDay;
          } else if (initialFtHours <= fullDay && !isHourlyRate) {
            ftHours = fullDay;
          } else {
            // Round up to nearest 0.5
            ftHours = Math.ceil(initialFtHours * 2) / 2;
          }
          estimate =
            ftHours * appliedRate +
            dtHours * (appliedRate * 2) +
            midnightHoursPrice;
        }
      } else {
        let ftHours = 0;
        let initialFtHours = 0;
        otHours = Math.max(timeDiff - fullDay - dtHours, 0, fixedFt);
        // ftHours = timeDiff - otHours - dtHours;
        initialFtHours = timeDiff - otHours - dtHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      }
      return {
        estimate: roundToNearestHalf(estimate + travelAmount || 0),
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
        travelAmount,
      };
    }
  }
};